import React from 'react';
import {observer} from 'mobx-react';
import './inner-content.scss';
import {DisplayTypeEnum, Inches} from '../render-v2-d';
import {MatSecondary} from '../mat-secondary/mat-secondary';
import {Spirit} from '../spirit/spirit';
import {FrameBuilderStore} from '../frame-builder-store';

type Props = {
    maxCols: number;
    width: number;
    height: number;
    columnGap: Inches;
    store: FrameBuilderStore;
};

export const InnerContent = observer(({store, maxCols, width, height, columnGap}: Props) => {
    const {frame, inchToPx} = store;
    const {moulding} = frame;

    return (
        <div
            id="inner-content"
            style={{
                gridTemplateColumns: `repeat(${maxCols}, auto)`,
                gridTemplateRows: `${store.itemsCount(DisplayTypeEnum.Insignia) > 0 ? inchToPx(frame.railTop) : ''} ${store.isVertical ? `repeat(${store.itemsCount(DisplayTypeEnum.Doc)}, 1fr)` : '1fr'} ${store.itemsCount(DisplayTypeEnum.Lino) > 0 ? inchToPx(frame.railBottom) : ''}`,
                justifyContent: 'center',
                inset: `${inchToPx(moulding.mouldingThickness)}`,
                width: inchToPx(width),
                height: inchToPx(height),
                columnGap: inchToPx(columnGap),
                paddingTop: !store.itemsCount(DisplayTypeEnum.Insignia) ? inchToPx(frame.railTop) : '',
                paddingBottom: !store.itemsCount(DisplayTypeEnum.Lino) ? inchToPx(frame.railBottom) : '',
            }}
        >
            {frame.displayMatrix.map((row, rIdx) =>
                row.map((item, cIdx) => {
                    if (!item) return null;

                    const isDoc = item.displayType === DisplayTypeEnum.Doc;

                    return (
                        <div
                            key={`${rIdx}-${cIdx}`}
                            style={{
                                gridRow: `${item.rowSpan || 1}`,
                                gridColumn: `${item.colSpan || 1}`,
                                marginBottom: isDoc ? inchToPx(item.gapBelow) : 0,
                            }}
                            className="inner-container"
                        >
                            {isDoc && (item.mat2Color || item.mat2ImageURL) ? (
                                <MatSecondary
                                    item={item}
                                    store={store}
                                />
                            ) : (
                                <img
                                    src={item.url}
                                    alt={item.displayType}
                                    style={{
                                        width: item.width === -1 ? 'auto' : inchToPx(item.width),
                                        height: item.height === -1 ? 'auto' : inchToPx(item.height),
                                    }}
                                />
                            )}
                        </div>
                    );
                }),
            )}

            {frame.spiritMode && <Spirit store={store} />}
        </div>
    );
});
